import { ComponentProps } from 'react';
import { Box } from '@qga/roo-ui/components';

import Skeleton from '@shared/v2/components/Skeleton';

import ImageGallery from '@/shared/components/ImageGallery';
import MissingImage from '@/v2/components/ui/MissingImage';
import { PropertyImage } from '@/v2/services/availability/types/api/parsedResponse';

export type PicturesProps = {
  mainImage: PropertyImage | null;
  images: PropertyImage[] | null;
  roomName: string;
} & ComponentProps<typeof Box>;

const sortImages = (
  images: PropertyImage[] | null,
  mainImage: PropertyImage | null,
) => {
  if (!images) {
    return undefined;
  }
  if (!mainImage) {
    return images;
  }
  return [
    mainImage,
    ...(images?.filter((img) => img.large !== mainImage.large) ?? []),
  ];
};

const Pictures = ({
  mainImage,
  images,
  roomName,
  height = ['200px', null, '250px'],
  ...boxProps
}: PicturesProps) => {
  const sortedImages = sortImages(images, mainImage);

  return (
    <Box
      flex="0 0 auto"
      position="relative"
      width={['100%', null, '370px']}
      {...boxProps}
    >
      <Skeleton height={height} lineHeight="unset">
        {sortedImages?.length ? (
          <ImageGallery
            altText={roomName}
            images={sortedImages}
            height={height}
          />
        ) : (
          <MissingImage height={height} />
        )}
      </Skeleton>
    </Box>
  );
};

export default Pictures;
